import accounting from "accounting";
import currencies from "@/config/currencies";
import vue from "vue";
import { number } from "@amcharts/amcharts4/core";
export function getCurrencySign(currencyName) {
  const currencySign = currencies[currencyName].sign;
  return currencySign;
}

// Заменяем все вхождения запятой на точку
export function replaceCommas(number) {
  return Number(String(number).replace(",", "."));
}

// Форматируем цифру (до вида - 13534.45)
export function formatMoney(number, precision = 2, thousand = " ") {
  number = replaceCommas(number);
  return accounting.formatNumber(number, precision, thousand);
}

// Возвращаем разницу в ценах для определения доходности
export function income(lastNumber, startNumber) {
  return lastNumber - startNumber;
}

// Возвращает только еденицы баланса в выбранной валюте
export function filterCurrencyPortfolioByCurrency(currencyPortfolio, currency) {
  if (!currencyPortfolio) {
    return [];
  }
  return currencyPortfolio.filter(item => item.CURRENCY === currency);
}

export function balanceInCurrency(currencyPortfolio, currency) {
  let balance = filterCurrencyPortfolioByCurrency(currencyPortfolio, currency);
  if (!balance) {
    return 0;
  }

  // Высчитываем сумму баланса в отфильтрованном массиве и округляем его до сотых
  balance = balance.reduce((previousValue, currentValue) => {
    let freeAmount;
    let blockedAmount;
    // Ошибка возвращается в тех случаях, когда денег в выбранной валюте нет на балансе
    try {
      freeAmount = Number(currentValue.FREE_AMOUNT);
      blockedAmount = Number(currentValue.BLOCKED_AMOUNT);
    } catch (e) {
      freeAmount = 0;
      blockedAmount = 0;
    }
    return previousValue + freeAmount + blockedAmount;
  }, 0);
  return balance;
}
